<template>
  <div>
    <div v-if="isShow" class="popFixed">
      <div class="masking" @click="closeFacePop" />
      <div class="tcCon">
        <div class="item">
          <img class="facePic" src="@/assets/images/personalInfo/video.png">
        </div>
        <div class="btnCon" :class="pageType=='app'?'only':''">
          <span v-if="pageType!='app'" @click="closeFacePop">取消</span>
          <span @click="goFaceValidate">开始识别</span>
        </div>
      </div>
    </div>
    <div v-if="isSuc" class="popFixed">
      <div class="masking" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p>{{ promptTxt }}</p>
        </div>
        <div class="btnCon only">
          <span @click="clickBtn">{{ megLiveTxt }}</span>
        </div>
      </div>
    </div>
    <div v-if="isNoFaceChannelPop" class="popFixed">
      <div class="masking" @click="closeNoFaceChannelPop" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p>暂无通道服务， 请稍后重试。</p>
        </div>
        <div class="btnCon only">
          <span @click="closeNoFaceChannelPop">我知道了</span>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import api from '@/plugins/api'

export default {
  name: 'FacePop',
  props: ['source', 'isFacePop', 'faceDetection', 'faceChannel', 'pageType', 'version', 'sourceType'],
  data() {
    const u = navigator.userAgent
    return {
      isShow: this.isFacePop,
      isSuc: false,
      isNoFaceChannelPop: false,
      promptTxt: '',
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      www_url: process.env.VUE_APP_WWW,
      megLiveTxt: '知道了',
      megLiveStatus: -1,
      url: '',
      appObj: ''
    }
  },
  mounted() {
    if (this.pageType == 'app') {
      window.setFaceVerifyResult = (...arg) => {
        this.setFaceVerifyResult(...arg)
      }
    }
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    closeFacePop() {
      if (this.pageType != 'app') {
        if (this.source == 'home') {
          this.removeFixed()
          this.isShow = false
          this.$emit('changeFacePop', this.isShow)
        } else {
          this.$router.go(-1)
        }
      }
    },
    closeNoFaceChannelPop() {
      this.isNoFaceChannelPop = false
    },  
    clickBtn() {
      if (this.megLiveStatus == 5) {
        window.location.reload()
      } else if (this.megLiveStatus == 1) {
        this.removeFixed()
        this.isSuc = false
        this.toMegLive()
      } else if (this.megLiveStatus == 2 || this.megLiveStatus == 4) {
        this.$bus.$emit('loading', false)
        this.$router.push({ path: '/home/credentials', query: { faceType: this.faceDetection.faceType }})
      } else if (this.megLiveStatus == 3) {
        try {
          let v
          if (this.isIOS) {
            if (typeof (window.closeAction) != 'undefined') {
              v = window.closeAction()
            } else {
              v = window.webkit.messageHandlers.closeAction.postMessage(null)
            }
          } else {
            v = window.uiObject.closeAction()
          }
        } catch (e) {
          alert(e)
        }
      } else if (this.megLiveStatus == 6) {
        this.removeFixed()
        this.isSuc = false
      }
    },
    goFaceValidate() {
      if (this.pageType == 'app') {
        if (this.faceDetection.isFaceValidate) this.toMegLive()
      } else {
        this.$bus.$emit('loading', false)
        this.$router.push({ path: '/home/faceValidate' })
      }
    },
    toMegLive() {
      // face++通道调用
      if (this.faceChannel == 'FACEID') {
        try {
          let v
          if (this.isIOS) {
            if (typeof (window.megLive) != 'undefined') {
              v = window.megLive()
            } else {
              v = window.webkit.messageHandlers.megLive.postMessage(null)
            }
          } else {
            v = window.uiObject.megLive()
          }
        } catch (e) {
          alert(e)
        }
      } else if (this.faceChannel == 'RONGXIN') {
        // 融信通道
        try {
          let v
          if (this.isIOS) {
            if (typeof (window.rongXLive) != 'undefined') {
              v = window.rongXLive()
            } else {
              v = window.webkit.messageHandlers.rongXLive.postMessage(null)
            }
          } else {
            v = window.uiObject.rongXLive()
          }
        } catch (e) {
          alert(e)
        }
      } else if (this.faceChannel == 'GLAD') {
        // 融信通道
        try {
          let v
          if (this.isIOS) {
            if (typeof (window.toMegLive) != 'undefined') {
              v = window.toMegLive()
            } else {
              v = window.webkit.messageHandlers.toMegLive.postMessage(null)
            }
          } else {
            v = window.uiObject.toMegLive()
          }
        } catch (e) {
          alert(e)
        }
      } else {
        this.isNoFaceChannelPop = true
      }
    },
    setFaceVerifyResult(isSuccess, megLiveDelta, megLiveImageBest) {
      this.$bus.$emit('loading', false)
      let first
      if (this.isIOS) {
        first = megLiveImageBest
      } else {
        first = isSuccess
      }
      this.isShow = false
      if (first == 'true' || first == true || first) {
        const data = {
          megLiveDelta: megLiveDelta,
          megLiveImageBest: megLiveImageBest,
          faceType: this.faceDetection.faceType,
          verificationType: this.faceDetection.verificationType,
          faceUuid: this.faceDetection.faceUuid,
          faceMethod: this.faceChannel
        }
        api.faceVerity(this.$qs.stringify(data)).then(res => {
          if (res.data.code == 200) {
            const data = res.data.data
            if (data.flag == '1') {
              this.$bus.$emit('loading', true)
              this.megLiveStatus = 0
              this.removeFixed()
              this.isSuc = false
              this.$emit('changeFacePop', this.isSuc)
            } else if (data.flag == '500') {
              this.$bus.$emit('loading', true)
              this.isSuc = true
              this.promptTxt = '识别次数超过10次，请联系客服'
              this.megLiveTxt = '确认'
              this.megLiveStatus = 6
            } else {
              if (data.flag == '-1' && (data.verifyCode == '2001' || data.verifyCode == '3016')) {
                this.FaceAuthorityFail(this.faceDetection.faceType)
              } else {
                this.$bus.$emit('loading', true)
                this.isSuc = true
                if (this.faceChannel == 'RONGXIN' || this.faceChannel == 'GLAD') {
                  this.promptTxt = data.errormessage
                } else {
                  this.promptTxt = '识别失败，请继续人脸识别'
                }
                this.megLiveTxt = '重新识别'
                this.megLiveStatus = 1
              }
            }
          } else {
            this.$bus.$emit('loading', true)
            this.isSuc = true
            this.promptTxt = '识别失败，请继续人脸识别'
            this.megLiveTxt = '重新识别'
            this.megLiveStatus = 1
          }
        })
      } else {
        this.$bus.$emit('loading', true)
        this.isSuc = true
        this.promptTxt = '识别失败，请继续人脸识别'
        this.megLiveTxt = '重新识别'
        this.megLiveStatus = 1
      }
    },
    FaceAuthorityFail(data) {
      api.getFailFaceAuthority(data).then(res => {
        if (res.data.code == 200) {
          this.$bus.$emit('loading', true)
          const data = res.data.data
          if (data.flag == '1') {
            this.megLiveStatus = 0
            this.removeFixed()
            this.isSuc = false
            this.$emit('changeFacePop', this.isSuc)
          } else if (data.flag == '3') {	// 未审核通过手持证件照
            if (data.holdCardStatus == 'EMPTY') {
              this.isSuc = true
              this.promptTxt = '为保证您的账户安全，证明是本人操作，请上传手持身份证证明文件，审核通过后即可进行人脸识别存、取款操作，谢谢您的配合，如有问题，可联系客服'
              this.megLiveTxt = '去认证'
              this.megLiveStatus = 2
            } else if (data.holdCardStatus == 'PRE_APPROVAL') {
              this.isSuc = true
              this.promptTxt = '您的资料在审核中，请耐心等待审核结果，审核结果将在1-3个工作日内完成，如有疑问，请联系客服！'
              this.megLiveTxt = '确认'
              this.megLiveStatus = 3
            } else if (data.holdCardStatus == 'CANCEL') {
              this.isSuc = true
              this.promptTxt = '您的资料审核失败，失败原因：' + data.reason + ',如有疑问，请联系客服！'
              this.megLiveTxt = '重新认证'
              this.megLiveStatus = 4
            }
          } else if (data.flag == '4') {
            this.isSuc = true
            this.promptTxt = '网络异常，请刷新重试！'
            this.megLiveTxt = '刷新'
            this.megLiveStatus = 5
          } else {
            this.isSuc = true
            this.promptTxt = '识别失败，请继续人脸识别'
            this.megLiveTxt = '重新识别'
            this.megLiveStatus = 1
          }
        } else {
          this.$bus.$emit('loading', true)
          this.isSuc = true
          this.promptTxt = '识别失败，请继续人脸识别'
          this.megLiveTxt = '重新识别'
          this.megLiveStatus = 1
        }
      })
    }
  }
}
</script>
